var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3894461559/src/~/core-js/library/modules/_has.js
// module id = MEt7
// module chunks = 6